import {
  ICreateUserProfileRequest,
  IUpdateUserProfileRequest,
  IUserProfile,
} from '../interfaces/heavyDutyMachinery/IUserProfile';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';
import { getLocalStorageKey } from '../helpers/localStorageHelper';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

const isNotFound = (error?: string): boolean => !!error && error.startsWith('HTTP Error: 404');

/** Returns undefined (not an error) when the caller hasn't completed registration's step 2 yet. */
export const getMyUserProfile = async (): Promise<IUserProfile | undefined> => {
  const response = await apiService<IUserProfile>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_USER_PROFILE_ME,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  if (isNotFound(response.error)) return undefined;
  throw new Error(response.error || 'Failed to load user profile');
};

export const createUserProfile = async (request: ICreateUserProfileRequest): Promise<IUserProfile> => {
  const response = await apiService<IUserProfile>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_USER_PROFILE_CREATE,
    method: HTTP_METHODS.POST,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to create user profile');
};

export const updateMyUserProfile = async (request: IUpdateUserProfileRequest): Promise<IUserProfile> => {
  const response = await apiService<IUserProfile>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_USER_PROFILE_ME,
    method: HTTP_METHODS.PUT,
    body: { ...request },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to update user profile');
};

/**
 * "Configuración > Privacidad > Solicitar mis datos personales" (RGPD) --
 * the backend returns a raw JSON file (not the usual ApiResponse<T> envelope),
 * so this bypasses apiService and triggers a browser download directly
 * instead of parsing a response body.
 */
export const downloadMyDataExport = async (): Promise<void> => {
  const accessToken = getLocalStorageKey('accessToken');
  const response = await fetch(`${heavyDutyMachineryBaseUrl}${API_ENDPOINTS.HEAVY_DUTY_MACHINERY_USER_PROFILE_DATA_EXPORT}`, {
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
  });
  if (!response.ok) throw new Error(`Failed to export data (HTTP ${response.status})`);

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `heavyDutyMachinery-data-export-${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
